import { render, staticRenderFns } from "./PriceVariant.vue?vue&type=template&id=4cc92de1&scoped=true&"
import script from "./PriceVariant.vue?vue&type=script&lang=js&"
export * from "./PriceVariant.vue?vue&type=script&lang=js&"
import style0 from "./PriceVariant.vue?vue&type=style&index=0&id=4cc92de1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc92de1",
  null
  
)

export default component.exports